import { gql } from 'apollo-angular';

import { TEMPLATE_BASE_FRAGMENT } from 'graphql/fragments/template-base';

export const TEMPLATE_FRAGMENT = gql`
  fragment TemplateFragment on Template {
    ...TemplateBaseFragment
  }
  ${TEMPLATE_BASE_FRAGMENT}
`;
